module.exports = __webpack_public_path__ + "img/conteudo-transicao.da3828c8.png";